import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalNotificationPanelService {
  notificationVisible = signal(false);
  notificationText = signal('');
  allowUserClose = signal(true);

  showGlobalNotificationPanel(text: string, allowUserClose: boolean): void {
    this.notificationText.set(text || '(text missing)');
    this.notificationVisible.set(true);
    this.allowUserClose.set(allowUserClose);
  }

  hideGlobalNotificationPanel(): void {
    this.notificationVisible.set(false);
  }
}
